
import { Component, Inject, Vue } from 'vue-property-decorator';
import SplashScaffold from '../SplashScaffold.vue';
import GlobalViewModel from '@/state/GlobalViewModel';
import GlossRepository from '@/repositories/GlossRepository';
import ReferenceDataRepository from '@/repositories/ReferenceDataRepository';
import SearchThemeSelector from '@/components/SearchThemeSelector.vue';
import Theme from '@/repositories/data/Theme';
import { Subscription } from 'rxjs';
import Resource, { ResourceStatus } from '@/repositories/Resource';
import Page from '@/repositories/data/Page';
import GlossSearchResult from '@/repositories/data/GlossSearchResult';
import { switchMap } from 'rxjs/operators';
import InformationBulb from '@/components/InformationBulb.vue';
import MediaFileVideoPlayer from '@/components/MediaFileVideoPlayer.vue';
import ContentWithOverlay from '@/components/ContentWithOverlay.vue';

@Component({
    components: {
        ContentWithOverlay,
        MediaFileVideoPlayer,
        SearchThemeSelector,
        SplashScaffold,
        InformationBulb,
    },
})
export default class SplashScreen extends Vue {
    public newResults: GlossSearchResult[] | null = null;
    public currentlyPlayingVideoId: string | null = null;
    public availableThemes: Theme[] = [];
    public referenceDataLoading = true;

    private newLoading: boolean = true;
    private searchSubscription = new Subscription();
    private newGlossesSubscription = new Subscription();
    private referenceDataSubscription = new Subscription();
    @Inject() private readonly globalViewModel!: GlobalViewModel;
    @Inject() private readonly glossRepository!: GlossRepository;
    @Inject() private readonly referenceDataRepository!: ReferenceDataRepository;

    public created(): void {
        this.newGlossesSubscription = this.globalViewModel.verifiedUser
            .pipe(switchMap(user => this.glossRepository.findNewGlosses(4, null)))
            .subscribe((glossPageResource: Resource<Page<GlossSearchResult>>) => {
                if (glossPageResource.status === ResourceStatus.SUCCESS) {
                    this.newLoading = false;
                    this.newResults = glossPageResource.data !== null ? glossPageResource.data.nodes : [];
                } else {
                    this.newLoading = glossPageResource.status === ResourceStatus.LOADING;
                }
            });

        this.referenceDataSubscription = this.globalViewModel.verifiedUser
            .pipe(switchMap(() => this.referenceDataRepository.findReferenceData(null)))
            .subscribe(referenceDataResource => {
                this.referenceDataLoading = referenceDataResource.status === ResourceStatus.LOADING;
                this.availableThemes =
                    referenceDataResource.data !== null && referenceDataResource.data.themes
                        ? referenceDataResource.data.themes
                        : [];
            });
    }

    public beforeDestroy(): void {
        this.searchSubscription.unsubscribe();
        this.newGlossesSubscription.unsubscribe();
        this.referenceDataSubscription.unsubscribe();
    }

    public onSearchByWord(): void {
        this.$router.push({ name: 'search', query: { q: '' } });
    }

    public onSearchByParameters(): void {
        this.$router.push({ name: 'search', query: { m: 'parameters' } });
    }

    public onSearchByGeolocation(): void {
        this.$router.push({ name: 'search', query: { m: 'geolocation' } });
    }

    public onSearchByTheme(themeId: string | null): void {
        if (!themeId) {
            return;
        }
        this.$router.push({ name: 'search', query: { q: '', t: themeId } });
    }

    public onSearchRecent() {
        this.$router.push({ name: 'search', query: { o: 'recent' } });
    }
}
